import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, tap, withLatestFrom } from 'rxjs/operators';

import { WorkflowService } from '../../../core/workflow/workflow.service';
import { RootState } from '../../store';
import { workflowLoad, workflowReset, workflowStepComplete } from './workflow.actions';
import { LoadWorkflowModel } from './workflow.model';

export const load = createEffect(
  (actions$ = inject(Actions), workflowService = inject(WorkflowService)) => {
    return actions$.pipe(
      ofType(workflowLoad),
      map(action => action.payload),
      tap((payload: LoadWorkflowModel) => {
        workflowService.workflowUnsubscribe();
        if (payload.activatedRoute) {
          workflowService.workflowSubscribe(payload.activatedRoute);
        }
      })
    );
  },
  { dispatch: false, functional: true }
);

export const reset = createEffect(
  (actions$ = inject(Actions), workflowService = inject(WorkflowService)) => {
    return actions$.pipe(
      ofType(workflowReset),
      tap(() => {
        workflowService.workflowUnsubscribe();
      })
    );
  },
  { dispatch: false, functional: true }
);
export const completeStep = createEffect(
  (
    actions$ = inject(Actions),
    store = inject(Store<RootState>),
    workflowService = inject(WorkflowService)
  ) => {
    return actions$.pipe(
      ofType(workflowStepComplete),
      map(action => action.payload),
      withLatestFrom(store.select(state => state.workflow)),
      tap(([payload, workflow]) => {
        if (payload && workflow.steps[payload.step].nextStep !== workflow.activeStep) {
          workflowService.workflowError();
        }
      })
    );
  },
  { dispatch: false, functional: true }
);
